import { simpleSet } from '@r/reducers/utils';

const toggleCalculationModeMainModal = simpleSet as
  redux.reducers.calculationMode.modals.main;

export const main = toggleCalculationModeMainModal(
  'TOGGLE_CALCULATION_MODE_MAIN_MODAL',
  true
);
